import type { GeneratedImage, GeneratedImagesParams, GeneratedImagesResponse } from "../types/generatedImage";
import { ApiService } from "./ApiService";

export class GeneratedImagesService extends ApiService {
  static pathName = "/generated-images";

  static getAll = (
    params?: GeneratedImagesParams,
  ): Promise<GeneratedImagesResponse> => {
    const queryParams: Record<string, string | number> = {};
    if (params?.spaceId) queryParams.spaceId = params.spaceId;
    if (params?.page) queryParams.page = params.page;
    if (params?.limit) queryParams.limit = params.limit;

    return ApiService.get(this.pathName, undefined, undefined, queryParams);
  };

  static getOne = (id: string): Promise<GeneratedImage> => {
    return ApiService.get(`${this.pathName}/${id}`);
  };

  static rename = (id: string, name: string): Promise<GeneratedImage> => {
    return ApiService.patch(`${this.pathName}/${id}`, { name });
  };

  static remove = (id: string) => {
    return ApiService.delete(`${this.pathName}/${id}`);
  };
}
